<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="part1"> </p>
<p class="PN"><span href="#/xhtml/contents#c_part1" title="Link target outside of Sample">Part I</span></p>
<p class="PT"><span href="#/xhtml/contents#c_part1" title="Link target outside of Sample"><span class="SANS-BI">Golden Triangle (1968–87)</span></span></p>
<p class="PEP"><span class="ePub-I">When you’re good to Mama, Mama’s good to you.</span></p>
<p class="PEPC">—John Kander and Fred Ebb, <span class="ePub-I">Chicago</span></p>
<p class="PEP"><span class="ePub-I">The world wanders into many strange by-paths of affection. The love of a mother for her children is dominant, leonine, selfish, and unselfish.</span></p>
<p class="PEPC">—Theodore Dreiser</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?49b87055